'use strict';

export function UserResource($resource) {
  'ngInject';

  return $resource('/api/users/:id/:controller', 
  {
    id: '@_id'
  }, 
  {
    get: {
      method: 'POST',
      params: {
        id: 'me'
      }
    }
  });
  /*
  { 'get':    {method:'GET'},
  'save':   {method:'POST'},
  'query':  {method:'GET', isArray:true},
  'remove': {method:'DELETE'},
  'delete': {method:'DELETE'} };
  */
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.js